/**
 * Constantes relacionadas a arquivos
 */

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_FILES_PER_UPLOAD = 10;
export const MAX_URLS_PER_UPLOAD = 10;
export const MAX_CHANGELOG_LENGTH = 2000;
export const MIN_DOCUMENT_TITLE_LENGTH = 4;

export const ATTACHMENT_EXTENSIONS = [
  '.pdf',
  '.docx',
  '.txt',
  '.pptx',
  '.xlsx',
  '.xlsm',
  '.dgw',
  '.cdr',
  '.x_t',
] as const;

export const ATTACHMENT_ACCEPT = ATTACHMENT_EXTENSIONS.join(',');

// Two server limits that only happen to match: the document send one (`MAX_ELECTRONIC_ATTACHMENTS`)
// and the record attachment one (`MAX_GENERATED_RECORD_ATTACHMENTS`).
export const MAX_DOCUMENT_SEND_ATTACHMENTS = 10;
export const MAX_RECORD_ATTACHMENTS = 10;

export const INVALID_ATTACHMENT_FILE_MESSAGE =
  'Arquivo inválido. Verifique se a extensão e o tipo do arquivo são permitidos.';
